module.exports = __webpack_public_path__ + "static/face-mask-ccc016873ec610e0c41bd923349a4b17.png";